import { ModelRow, Navigation } from "@mcleod/core";
import { AutogenLayoutEscrowTransactionsList } from "./autogen/AutogenLayoutEscrowTransactionsList";
import {
    Button, ButtonVariant, ClickEvent, Label, LookupModelSearchEvent, TableRowCreationEvent
} from "@mcleod/components";
import { ImageName } from "@mcleod/images";

export class EscrowTransactionsList extends AutogenLayoutEscrowTransactionsList {

    onLoad(): void | Promise<void> {
        this.mainDataSource.orderBy = [
            { field: "check_date", sort: "desc" },
            { field: "payee_id", sort: "asc" },
            { field: "glid", sort: "asc" },
            { field: "id", sort: "desc" }
        ];

        this.tableEscrowTransaction.addRowCreateListener((event: TableRowCreationEvent) => {
            const newRow = event.getTableRow();
            if (!newRow.data.isNull("balance_data")){
                const balanceRow = new ModelRow(this.tableEscrowTransaction.dataSource.url, false, newRow.data.get("balance_data"));
                this.tableEscrowTransaction.redisplaySingleRow(null, balanceRow, true, true);
                newRow.data.set("balance_data", undefined);
            }
        });

        this.tableEscrowTransaction.doOnResolveRowEdit = (updatedRow: ModelRow) => {
            // Loop through all rows in the table to find matching adjustment_id
            const allRows = this.tableEscrowTransaction.allRows;
            const updatedRowId = updatedRow.get("id");
            const updatedRowDate = updatedRow.getDate("check_date");

            allRows.forEach(row => {
                const adjustmentId = row.data.get("adjust_id");
                if (adjustmentId && adjustmentId === updatedRowId) {
                    // Update the date on the found row with the date from the updated row
                    row.data.set("check_date", updatedRowDate);
                    row.displayComponentValues();
                 }
            });

            return Promise.resolve(updatedRow);
        }

        this.createReportButtons();

    }

    private createReportButtons() {
        const reportsButton  = new Button({
            id: "reportsButton",
            enabled: true,
            variant: ButtonVariant.round,
            imageName: ImageName.report,
            color: "primary",
            fontSize: "large",
            tooltip: "Reports",
            dropdownListProps: { maxHeight: 800 },
            dropdownItems: [new Label({
                id: "labelEscrowReconciliation",
                text: "Escrow Reconciliation",
                fillRow: true,
                rowBreak: false,
                onClick(event) {
                    Navigation.navigateTo("lme/settlement/EscrowReconciliation", { newTab: true });
                },
            }),
            new Label({
                id: "labelEscrowStatements",
                text: "Escrow Statements",
                fillRow: true,
                rowBreak: false,
                onClick(event) {
                    Navigation.navigateTo("lme/settlement/EscrowStatements", { newTab: true });
                },
            })
        ]});

        // This is an odd way to do this
        this.tableEscrowTransaction.removeTool(this.buttonCalculateInterest);
        this.tableEscrowTransaction.addRightTool(reportsButton);
        this.tableEscrowTransaction.addRightTool(this.buttonCalculateInterest);
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxPayeeIdSearch. */
    textboxPayeeIdSearchBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.non_office_emp = "Y";
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxGlidSearch. */
    textboxGlidSearchBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.isactive = "Y";
        event.filter.is_escrow = "Y";
    }

    /** This is an event handler for the onClick event of buttonCalculateInterest. */
    buttonCalculateInterestOnClick(event: ClickEvent) {
        Navigation.navigateTo("lme/settlement/CalculateEscrowInterest", { newTab: true });
    }
}
